import React, { useEffect } from 'react';
import { Grid, Typography } from "@mui/material";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaiementStripeForm from './PaiementStripeForm';
import "../css/stripe.css";

export default function PaiementStripe({ clientSecret }) {

	const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

	const options = {
		// passing the client secret obtained in step 2
		clientSecret,
		// Fully customizable with appearance API.
		appearance: { theme: 'stripe' },
	};
	
	useEffect(() => {
		const element = document.getElementById('paiementEnLigne');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}, []);

	return (
		<Grid container spacing={2} direction="row" justifyContent="center">
			<Grid item xs={12}>
				<Typography id="paiementEnLigne" component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
					Paiement en ligne
				</Typography>
			</Grid>

			<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
				{clientSecret && (
					<Elements stripe={stripePromise} options={options}>
						<PaiementStripeForm />
					</Elements>
				)}
			</Grid>
		</Grid>
	);
}